// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3Gp2f","gfeWrapper":"CalendarEvent_gfeWrapper__8XZL9"};